export abstract class AssRevMatsEvent {}

export class AssRevMatsLoad extends AssRevMatsEvent {}
